import { useCallback, useEffect, useState } from "react";
import {
  Form,
  Button,
  Row,
  Col,
  FloatingLabel,
  Container,
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useLocalizedRoutes } from "../../../hooks/useLocalizedRoutes";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import axiosApi from "../../../axios/axios-api";
import { MiniLoader } from "../../ui/MiniLoader";
import { ValidateToken } from "../../../helpers/validateToken";
import checkMatricula from "../../../functions/checkMatricula";
import Feedback from "react-bootstrap/esm/Feedback";
import { toast } from "react-toastify";
import { LogoPetroprix } from "../../ui/LogoPetroprix";
import { startLogout } from "../../../store/auth";

const URL_GET_CUENTAS_FACTURACION = "factura/cuentasFacturacion";
const URL_CREATE_VEHICULOS_FLOTA = "flotas/vehiculos";

export const RegistroVehiculoScreen = () => {
  const [validated, setValidated] = useState(false);
  const [cuentasFacturacion, setCuentasFacturacion] = useState([]);
  const [loadingCuentasFacturacion, setLoadingCuentasFacturacion] =
    useState(false);
  const [errorLoadingCuentas, setErrorLoadingCuentas] = useState(false);
  const [savingData, setSavingData] = useState(false);
  const [validatingMatricula, setValidatingMatricula] = useState(false);
  const [touchedMatricula, setTouchedMatricula] = useState(false);

  const { token, idClienteFlota } = useSelector((state) => state.auth);
  const { state } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { getPath } = useLocalizedRoutes();

  const [formData, setFormData] = useState({
    cuentaFacturacion: "",
    matricula: state ? state.matricula : "",
    personal: state ? state.personal : "",
    tipoVehiculo: state ? state.tipo_vehiculo : "",
    combustible: state ? state.tipo : "",
    factura: state ? state.factura : "",
    limiteCredito: "",
    cantidadLimite: "",
    pinTxt: "",
    pinTxtRepeat: "",
    impMaxRepost: "150",
    impMaxDiaPetroprix: "150",
    numRepostDia30Min: "3",
    descripcion: "",
  });

  const [formErrors, setFormErrors] = useState({
    cuentaFacturacion: false,
    matricula: false,
    personal: false,
    tipoVehiculo: false,
    combustible: false,
    factura: false,
    limiteCredito: false,
    cantidadLimite: false,
    pinTxt: false,
    pinTxtRepeat: false,
    impMaxRepost: false,
    impMaxDiaPetroprix: false,
    numRepostDia30Min: false,
  });

  const validateForm = async (onlyPlate = false) => {
    setValidated(false);
    setValidatingMatricula(true);

    const validateForm = {
      matricula: false,
      cuentaFacturacion: false,
      factura: false,
      tipoVehiculo: false,
      combustible: false,
      limiteCredito: false,
      cantidadLimite: false,
      pinTxt: false,
      pinTxtRepeat: false,
      impMaxRepost: false,
      impMaxDiaPetroprix: false,
      numRepostDia30Min: false,
    };

    if (onlyPlate) {
      if (formData.matricula === "") {
        validateForm.matricula = true;
        setValidatingMatricula(false);
        setFormErrors({ ...formErrors, matricula: true });
      } else {
        if (validateForm.matricula === false) {
          await checkMatricula(formData.matricula, token).then(
            (matriculaValida) => {
              if (matriculaValida?.code !== 200) {
                validateForm.matricula = true;
                setValidatingMatricula(false);
              } else {
                validateForm.matricula = false;
                setValidatingMatricula(false);
              }
              setFormErrors({
                ...formErrors,
                matricula: validateForm.matricula,
              });
            }
          );
        }
      }
    } else {
      if (formData.matricula === "") {
        validateForm.matricula = true;
        setValidatingMatricula(false);
      } else {
        if (validateForm.matricula === false && formData.personal !== true) {
          await checkMatricula(formData.matricula, token).then(
            (matriculaValida) => {
              if (matriculaValida?.code !== 200) {
                validateForm.matricula = true;
              } else {
                validateForm.matricula = false;
              }
            }
          );
        } else {
          validateForm.matricula = false;
        }
        setValidatingMatricula(false);
      }

      if (formData.cuentaFacturacion === "") {
        validateForm.cuentaFacturacion = true;
      } else {
        validateForm.cuentaFacturacion = false;
      }

      if (formData.factura == "") {
        validateForm.factura = true;
      } else {
        validateForm.factura = false;
      }

      if (formData.tipoVehiculo == "") {
        validateForm.tipoVehiculo = true;
      } else {
        validateForm.tipoVehiculo = false;
      }

      if (formData.combustible === "") {
        validateForm.combustible = true;
      } else {
        validateForm.combustible = false;
      }
      if (formData.combustible === "") {
        validateForm.combustible = true;
      } else {
        validateForm.combustible = false;
      }

      if (formData.limiteCredito === "") {
        validateForm.limiteCredito = true;
      } else if (formData.limiteCredito === "1") {
        if (formData.cantidadLimite === "") {
          validateForm.cantidadLimite = true;
        } else {
          validateForm.cantidadLimite = false;
        }
        validateForm.limiteCredito = false;
      } else {
        validateForm.limiteCredito = false;
        validateForm.cantidadLimite = false;
      }

      if (
        formData.pinTxt === "" ||
        formData.pinTxt.length !== 4 ||
        isNaN(formData.pinTxt)
      ) {
        validateForm.pinTxt = true;
        validateForm.pinTxtRepeat = true;
      } else if (
        formData.pinTxtRepeat === "" ||
        formData.pinTxtRepeat.length !== 4 ||
        isNaN(formData.pinTxtRepeat)
      ) {
        validateForm.pinTxtRepeat = true;
        validateForm.pinTxt = false;
      } else if (formData.pinTxt !== formData.pinTxtRepeat) {
        validateForm.pinTxtRepeat = true;
        validateForm.pinTxt = true;
      } else {
        validateForm.pinTxtRepeat = false;
        validateForm.pinTxt = false;
      }

      if (formData.impMaxRepost === "" || formData.impMaxRepost < 0) {
        validateForm.impMaxRepost = true;
      } else {
        validateForm.impMaxRepost = false;
      }

      if (
        formData.impMaxDiaPetroprix === "" ||
        formData.impMaxDiaPetroprix < 0
      ) {
        validateForm.impMaxDiaPetroprix = true;
      } else {
        validateForm.impMaxDiaPetroprix = false;
      }

      if (formData.numRepostDia30Min === "" || formData.numRepostDia30Min < 0) {
        validateForm.numRepostDia30Min = true;
      } else {
        validateForm.numRepostDia30Min = false;
      }

      setValidated(true);
    }

    setFormErrors({ ...formErrors, ...validateForm });

    if (
      validateForm.matricula ||
      validateForm.cuentaFacturacion ||
      validateForm.factura ||
      validateForm.tipoVehiculo ||
      validateForm.combustible ||
      validateForm.limiteCredito ||
      validateForm.cantidadLimite ||
      validateForm.pinTxt ||
      validateForm.pinTxtRepeat ||
      validateForm.impMaxRepost ||
      validateForm.impMaxDiaPetroprix ||
      validateForm.numRepostDia30Min
    ) {
      return false;
    } else {
      return true;
    }
  };

  // after form submit validating the form data using validator
  const handleSave = async (e) => {
    e.preventDefault();
    setSavingData(true);

    let validated = await validateForm();

    if (!validated) {
      setSavingData(false);
      return;
    }

    const data = {
      id_customer_fleet: idClienteFlota,
      id_billing_account: formData.cuentaFacturacion,
      plate_number: formData.matricula,
      vehicle_type: formData.tipoVehiculo,
      assigned_credit:
        formData.cantidadLimite === "-1"
          ? parseFloat(-1)
          : parseFloat(formData.limiteCredito),
      max_operation: Number(formData.impMaxRepost),
      max_op_red: Number(formData.impMaxDiaPetroprix),
      max_op_30: Number(formData.numRepostDia30Min),
      pin: formData.pinTxt,
      confirm_pin: formData.pinTxtRepeat,
      invoice: formData.factura,
      fuel_type: formData.combustible,
    };

    //Añadimos descripcion solo si no esta vacia
    if (formData.descripcion && formData.descripcion.trim() !== "") {
      data.description = formData.descripcion;
    }
    try {
      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        const response = await axiosApi.post(URL_CREATE_VEHICULOS_FLOTA, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        });
        if (response?.data?.code === 200) {
          toast(t("datos.vehiculos.nuevo.form.result.ok"), {
            icon: <LogoPetroprix />,
          });
          setSavingData(false);
          navigate(getPath('fleetsMyFleets'));
        } else {
          toast(response.data.message, {
            icon: <LogoPetroprix />,
          });
          setSavingData(false);
        }
      } else {
        dispatch(startLogout("expired"));
      }
    } catch (error) {
      setSavingData(false);
      console.error(error);
    }
  };

  const fetchCuentasFacturacion = useCallback(async () => {
    setLoadingCuentasFacturacion(true);
    try {
      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        const response = await axiosApi.get(URL_GET_CUENTAS_FACTURACION, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        });
        if (response?.data?.code === 200) {
          let data = response.data.data;
          setCuentasFacturacion(data);
          setErrorLoadingCuentas(false);
          setLoadingCuentasFacturacion(false);
        } else {
          setCuentasFacturacion([]);
          setErrorLoadingCuentas(false);
          setLoadingCuentasFacturacion(false);
        }
      } else {
        setCuentasFacturacion([]);
        setLoadingCuentasFacturacion(false);
        setErrorLoadingCuentas(true);
        dispatch(startLogout("expired"));
      }
    } catch (error) {
      setCuentasFacturacion([]);
      setLoadingCuentasFacturacion(false);
      setErrorLoadingCuentas(true);
      console.error(error);
    }
  }, []);

  useEffect(() => {
    fetchCuentasFacturacion();
  }, [fetchCuentasFacturacion]);

  useEffect(() => {
    if (cuentasFacturacion.length > 0) {
      setFormData({
        ...formData,
        cuentaFacturacion: cuentasFacturacion[0].billingAccountId,
      });
    }
  }, [cuentasFacturacion]);

  return (
    <>
      <Container className="content-body mt-4 px-4">
        <Form
          className="datos-nuevo-vehiculo"
          autoComplete="off"
          onSubmit={(e) => handleSave(e)}
          noValidate
          validated={validated}
          name="datos-nuevo-vehiculo"
        >
          <Container>
            <Row className="page-header">
              <Col xs={12} sm={12} lg={9}>
                <h1>{t("flotas.registro-vehiculo.header.h1")}</h1>
              </Col>
            </Row>
          </Container>
          <Container className="mt-1 bg-white radius-8">
            <Row
              className="content-section"
              style={{ padding: "2em", overflowX: "scroll" }}
            >
              <>
                <Row>
                  {/* Cuenta de Facturación */}
                  <Col sm={12} lg={6}>
                    {!loadingCuentasFacturacion ? (
                      <FloatingLabel
                        label={t(
                          "flotas.registro-vehiculo.step-1.form.cuenta-facturacion"
                        )}
                        className="mb-3"
                      >
                        <Form.Select
                          aria-label={t(
                            "flotas.registro-vehiculo.step-1.form.cuenta-facturacion"
                          )}
                          placeholder={t(
                            "flotas.registro-vehiculo.step-1.form.cuenta-facturacion"
                          )}
                          defaultValue={formData.cuentaFacturacion}
                          required
                          disabled={loadingCuentasFacturacion}
                          isInvalid={validated && formErrors.cuentaFacturacion}
                          isValid={validated && !formErrors.cuentaFacturacion}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              cuentaFacturacion: e.target.value,
                            })
                          }
                        >
                          {cuentasFacturacion.map((cuenta) => (
                            <option
                              key={cuenta.billingAccountId}
                              value={`${cuenta.name + cuenta.lastName}`}
                            >
                              {cuenta.name} {cuenta.lastName}
                            </option>
                          ))}
                        </Form.Select>
                        <Feedback type="invalid">
                          {t(
                            "flotas.registro-vehiculo.step-1.form.cuenta-facturacion.invalid"
                          )}
                        </Feedback>
                      </FloatingLabel>
                    ) : (
                      <MiniLoader height="38px" />
                    )}
                  </Col>

                  {/* Matrícula */}
                  <Col sm={12} lg={6}>
                    <FloatingLabel
                      label={t(
                        "flotas.registro-vehiculo.step-1.form.matricula"
                      )}
                      className="mb-3"
                    >
                      <Form.Control
                        type="text"
                        maxLength="12"
                        placeholder={t(
                          "flotas.registro-vehiculo.step-1.form.matricula"
                        )}
                        defaultValue={formData.matricula}
                        readOnly={formData.personal === true ? true : false}
                        onBlur={() => {
                          formData.personal !== true && validateForm(true);
                          setTouchedMatricula(true);
                        }}
                        required
                        isInvalid={
                          (touchedMatricula || validated) &&
                          !validatingMatricula &&
                          formErrors.matricula
                        }
                        isValid={
                          (touchedMatricula || validated) &&
                          !validatingMatricula &&
                          !formErrors.matricula
                        }
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            matricula: e.target.value,
                          })
                        }
                      />
                      {validatingMatricula && (
                        <>
                          <div className="datos-form-validating">
                            <MiniLoader />
                          </div>
                          <p className="datos-form-validating-text">
                            {t(
                              "datos.vehiculos.nuevo.form.validating.matricula"
                            )}
                          </p>
                        </>
                      )}
                      {!validatingMatricula && (
                        <Feedback type="invalid">
                          {t(
                            "flotas.registro-vehiculo.step-1.form.matricula.invalid"
                          )}
                        </Feedback>
                      )}
                    </FloatingLabel>
                  </Col>


            
                  {/* Factura */}
                  <Col sm={12} lg={6}>
                    <FloatingLabel
                      label={t("flotas.registro-vehiculo.step-1.form.factura")}
                      className="mb-3"
                    >
                      <Form.Select
                        aria-label={t(
                          "flotas.registro-vehiculo.step-1.form.factura"
                        )}
                        placeholder={t(
                          "flotas.registro-vehiculo.step-1.form.factura"
                        )}
                        defaultValue={formData.factura}
                        required
                        isInvalid={validated && formErrors.factura}
                        isValid={validated && !formErrors.factura}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            factura: e.target.value,
                          })
                        }
                      >
                        <option value="" disabled>
                          {t(
                            "flotas.registro-vehiculo.step-1.form.factura.select"
                          )}
                        </option>
                        <option value="1">
                          {t("flotas.registro-vehiculo.step-1.form.factura.si")}
                        </option>
                        <option value="0">
                          {t("flotas.registro-vehiculo.step-1.form.factura.no")}
                        </option>
                      </Form.Select>
                      <Feedback type="invalid">
                        {t(
                          "flotas.registro-vehiculo.step-1.form.factura.invalid"
                        )}
                      </Feedback>
                    </FloatingLabel>
                  </Col>

                  {/* Descripción */}
                  <Col sm={12} lg={6}>
                    <FloatingLabel
                      label={t(
                        "flotas.registro-vehiculo.step-1.form.descripcion"
                      )}
                      className="mb-3"
                    >
                      <Form.Control
                        type="text"
                        maxLength="12"
                        placeholder={t(
                          "flotas.registro-vehiculo.step-1.form.descripcion"
                        )}
                        defaultValue={formData.descripcion}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            descripcion: e.target.value,
                          })
                        }
                      />
                      <Feedback type="invalid">
                        {t(
                          "flotas.registro-vehiculo.step-1.form.descripcion.invalid"
                        )}
                      </Feedback>
                    </FloatingLabel>
                  </Col>

                  {/* Tipo de Vehículo */}
                  <Col sm={12} lg={6}>
                    <FloatingLabel
                      label={t(
                        "flotas.registro-vehiculo.step-1.form.tipo-vehiculo"
                      )}
                      className="mb-3"
                    >
                      <Form.Select
                        aria-label={t(
                          "flotas.registro-vehiculo.step-1.form.tipo-vehiculo"
                        )}
                        placeholder={t(
                          "flotas.registro-vehiculo.step-1.form.tipo-vehiculo"
                        )}
                        defaultValue={formData.tipoVehiculo}
                        required
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            tipoVehiculo: e.target.value,
                          });
                        }}
                        isInvalid={validated && formErrors.tipoVehiculo}
                        isValid={validated && !formErrors.tipoVehiculo}
                      >
                        <option value="" disabled>
                          {t(
                            "flotas.registro-vehiculo.step-1.form.tipo-vehiculo.select"
                          )}
                        </option>
                        <option value="0">
                          {t(
                            "flotas.registro-vehiculo.step-1.form.tipo-vehiculo.turismo"
                          )}
                        </option>
                        <option value="1">
                          {t(
                            "flotas.registro-vehiculo.step-1.form.tipo-vehiculo.moto"
                          )}
                        </option>
                        <option value="2">
                          {t(
                            "flotas.registro-vehiculo.step-1.form.tipo-vehiculo.camion"
                          )}
                        </option>
                      </Form.Select>
                      <Feedback type="invalid">
                        {t(
                          "flotas.registro-vehiculo.step-1.form.tipo-vehiculo.invalid"
                        )}
                      </Feedback>
                    </FloatingLabel>
                  </Col>

                  {/* Combustible */}
                  <Col sm={12} lg={6}>
                    <FloatingLabel
                      label={t(
                        "flotas.registro-vehiculo.step-1.form.combustible"
                      )}
                      className="mb-3"
                    >
                      <Form.Select
                        aria-label={t(
                          "flotas.registro-vehiculo.step-1.form.combustible"
                        )}
                        placeholder={t(
                          "flotas.registro-vehiculo.step-1.form.combustible"
                        )}
                        defaultValue={formData.combustible}
                        required
                        isInvalid={validated && formErrors.combustible}
                        isValid={validated && !formErrors.combustible}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            combustible: e.target.value,
                          });
                        }}
                      >
                        <option value="" disabled>
                          {t(
                            "flotas.registro-vehiculo.step-1.form.combustible.select"
                          )}
                        </option>
                        <option value="Diesel">
                          {t(
                            "flotas.registro-vehiculo.step-1.form.combustible.diesel"
                          )}
                        </option>
                        <option value="Gasolina">
                          {t(
                            "flotas.registro-vehiculo.step-1.form.combustible.gasolina"
                          )}
                        </option>
                      </Form.Select>
                      <Feedback type="invalid">
                        {t(
                          "flotas.registro-vehiculo.step-1.form.combustible.invalid"
                        )}
                      </Feedback>
                    </FloatingLabel>
                  </Col>

                  {/* PIN */}
                  <Col sm={12} lg={3}>
                    <FloatingLabel
                      label={t(
                        "flotas.registro-vehiculo.step-1.form.pin-input"
                      )}
                      className="mb-3"
                    >
                      <Form.Control
                        type="password"
                        placeholder={t(
                          "flotas.registro-vehiculo.step-1.form.pin-input"
                        )}
                        defaultValue={formData.pinTxt}
                        maxLength="4"
                        pattern="[0-9]{4}"
                        required
                        autoComplete="new-password"
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            pinTxt: e.target.value,
                          });
                        }}
                        isInvalid={validated && formErrors.pinTxt}
                        isValid={validated && !formErrors.pinTxt}
                      />
                      <Feedback type="invalid">
                        {t(
                          "flotas.registro-vehiculo.step-1.form.pin-input.invalid"
                        )}
                      </Feedback>
                    </FloatingLabel>
                  </Col>

                  {/* Repetir PIN */}
                  <Col sm={12} lg={3}>
                    <FloatingLabel
                      label={t(
                        "flotas.registro-vehiculo.step-1.form.pin-repeat"
                      )}
                      className="mb-3"
                    >
                      <Form.Control
                        type="password"
                        placeholder={t(
                          "flotas.registro-vehiculo.step-1.form.pin-repeat"
                        )}
                        defaultValue={formData.pinTxtRepeat}
                        maxLength="4"
                        pattern="[0-9]{4}"
                        required
                        autoComplete="new-password"
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            pinTxtRepeat: e.target.value,
                          })
                        }
                        isInvalid={validated && formErrors.pinTxtRepeat}
                        isValid={validated && !formErrors.pinTxtRepeat}
                      />
                      <Feedback type="invalid">
                        {t(
                          "flotas.registro-vehiculo.step-1.form.pin-repeat.invalid"
                        )}
                      </Feedback>
                    </FloatingLabel>
                  </Col>

                  {/* Límite de Crédito */}
                  <Col sm={12} lg={6}>
                    <FloatingLabel
                      label={t(
                        "flotas.registro-vehiculo.step-1.form.limite-credito"
                      )}
                      className="mb-3"
                    >
                      <Form.Select
                        aria-label={t(
                          "flotas.registro-vehiculo.step-1.form.limite-credito"
                        )}
                        placeholder={t(
                          "flotas.registro-vehiculo.step-1.form.limite-credito"
                        )}
                        defaultValue={formData.limiteCredito}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            limiteCredito: e.target.value,
                          })
                        }
                        required
                        isInvalid={validated && formErrors.limiteCredito}
                        isValid={validated && !formErrors.limiteCredito}
                      >
                        <option value="" disabled>
                          {t(
                            "flotas.registro-vehiculo.step-1.form.limite-credito.select"
                          )}
                        </option>
                        <option value="-1">
                          {t(
                            "flotas.registro-vehiculo.step-1.form.limite-credito.sin-limite"
                          )}
                        </option>
                        <option value="1">
                          {t(
                            "flotas.registro-vehiculo.step-1.form.limite-credito.definir"
                          )}
                        </option>
                      </Form.Select>
                      <Feedback type="invalid">
                        {t(
                          "flotas.registro-vehiculo.step-1.form.limite-credito.invalid"
                        )}
                      </Feedback>
                    </FloatingLabel>
                  </Col>

                  {/* Límite Mensual, solo si el límite de crédito es "Definir" */}
                  {formData.limiteCredito == 1 && (
                    <Col sm={12} lg={6}>
                      <FloatingLabel
                        label={t(
                          "flotas.registro-vehiculo.step-1.form.limite-mensual"
                        )}
                        className="mb-3"
                      >
                        <Form.Control
                          type="number"
                          placeholder={t(
                            "flotas.registro-vehiculo.step-1.form.limite-mensual"
                          )}
                          defaultValue={formData.cantidadLimite}
                          min="0"
                          required
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              cantidadLimite: e.target.value,
                            })
                          }
                          isInvalid={validated && formErrors.cantidadLimite}
                          isValid={validated && !formErrors.cantidadLimite}
                        />
                        <Feedback type="invalid">
                          {t(
                            "flotas.registro-vehiculo.step-1.form.limite-mensual.invalid"
                          )}
                        </Feedback>
                      </FloatingLabel>
                    </Col>
                  )}
                </Row>
              </>
            </Row>
          </Container>
          <Container className="mt-4">
            <Row className="page-header">
              <Col xs={12} sm={12} lg={9}>
                <h1>{t("flotas.registro-vehiculo.header.restricciones.h1")}</h1>
              </Col>
            </Row>
          </Container>
          <Container className="mt-1 mb-3 py-1 bg-white radius-8">
            <Row
              className="content-section mb-4"
              style={{ padding: "2em", overflowX: "scroll" }}
            >
              <>
                <Row>
                  {/* Importe Máximo de Repostaje */}
                  <Col sm={12} lg={6}>
                    <FloatingLabel
                      label={t(
                        "flotas.registro-vehiculo.step-2.form.imp-max-repost"
                      )}
                      className="mb-3"
                    >
                      <Form.Control
                        type="number"
                        min="0"
                        placeholder={t(
                          "flotas.registro-vehiculo.step-2.form.imp-max-repost"
                        )}
                        defaultValue={formData.impMaxRepost}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            impMaxRepost: e.target.value,
                          })
                        }
                        isInvalid={validated && formErrors.impMaxRepost}
                        isValid={validated && !formErrors.impMaxRepost}
                        required
                      />
                      <Feedback type="invalid">
                        {t(
                          "flotas.registro-vehiculo.step-2.form.imp-max-repost.invalid"
                        )}
                      </Feedback>
                    </FloatingLabel>
                  </Col>

                  {/* Importe Máximo de Repostaje Petroprix */}
                  <Col sm={12} lg={6}>
                    <FloatingLabel
                      label={t(
                        "flotas.registro-vehiculo.step-2.form.imp-max-repost-petroprix"
                      )}
                      className="mb-3"
                    >
                      <Form.Control
                        type="number"
                        min="0"
                        placeholder={t(
                          "flotas.registro-vehiculo.step-2.form.imp-max-repost-petroprix"
                        )}
                        defaultValue={formData.impMaxDiaPetroprix}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            impMaxDiaPetroprix: e.target.value,
                          })
                        }
                        isInvalid={
                          validated && formErrors.impMaxRepostPetroprix
                        }
                        isValid={validated && !formErrors.impMaxRepostPetroprix}
                        required
                      />
                      <Feedback type="invalid">
                        {t(
                          "flotas.registro-vehiculo.step-2.form.imp-max-repost-petroprix.invalid"
                        )}
                      </Feedback>
                    </FloatingLabel>
                  </Col>

                  {/* Nº Repostajes Diarios 30 minutos */}
                  <Col sm={12} lg={6}>
                    <FloatingLabel
                      label={t(
                        "flotas.registro-vehiculo.step-2.form.num-repost-dia-30min"
                      )}
                      className="mb-3"
                    >
                      <Form.Control
                        type="number"
                        min="0"
                        placeholder={t(
                          "flotas.registro-vehiculo.step-2.form.num-repost-dia-30min"
                        )}
                        defaultValue={formData.numRepostDia30Min}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            numRepostDia30Min: e.target.value,
                          })
                        }
                        isInvalid={validated && formErrors.numRepostDia30Min}
                        isValid={validated && !formErrors.numRepostDia30Min}
                        required
                      />
                      <Feedback type="invalid">
                        {t(
                          "flotas.registro-vehiculo.step-2.form.num-repost-dia-30min"
                        )}
                      </Feedback>
                    </FloatingLabel>
                  </Col>
                </Row>
              </>
            </Row>
          </Container>
          <Container className="mb-3">
            <Row>
              <Col xs={12} className="d-flex justify-content-end">
                <div className="d-grid gap-2" style={{ width: "auto" }}>
                  <Button
                    variant="primary"
                    size="lg"
                    className="btn-submit"
                    type="submit"
                    onClick={(e) => handleSave(e)}
                    disabled={
                      savingData ||
                      loadingCuentasFacturacion ||
                      errorLoadingCuentas
                    }
                  >
                    {savingData ? (
                      <MiniLoader />
                    ) : (
                      t("flotas.registro-vehiculo.step-2.form.add-next")
                    )}
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </Form>
      </Container>
    </>
  );
};
